import { configureStore } from "@reduxjs/toolkit";
import MenuState from "./state/MenuState";
import BuyerSellerFilterSlice from "./state/BuyerSellerState";
import DocumentSlice from "./state/DocumentState";
import ExchangeState from "./state/Exchange/ExchangeState";
import MarketMonitoringSlice from "./state/MarketMontitoring/MarketMonitoringState";
import DiscomSlice from "./state/Discom/Discom";
import viewModeReducer from "./state/ViewMode";
import defaultDatesSetterReducer from "./state/DefaultDatesSetter";
import FilterWidthSliceReducer from "./state/FilterWidth";
import demandForecastReducer from "./state/DemandForecast";
import switchTabs from "./state/SwitchTabs";
import BlockSuggestionSliceReducer from "./state/BlockSuggestion";
import disclamerModeleducer from "./state/disclamerModel";
import FilterLoadingStateSliceReducer from "./state/FilterLoadingState";
import modLoadReducer from "./state/ModLoadState";
import modGridcoDateReducer from "./state/ModGridco/ModDate";
import modGridcoSessionReducer from "./state/ModGridco/ModSession";
import modGridcoSessionTokenReducer from "./state/ModGridco/ModSessionToken";
import modGridcoVersionReducer from "./state/ModGridco/ModVersion";
import modDemoDateReducer from "./state/ModDemo/ModDate";
import modDemoSessionReducer from "./state/ModDemo/ModSession";
import modDemoSessionTokenReducer from "./state/ModDemo/ModSessionToken";
import modDemoVersionReducer from "./state/ModDemo/ModVersion";
import modRuvnlDateReducer from "./state/ModRuvnl/ModDate";
import modRuvnlSessionReducer from "./state/ModRuvnl/ModSession";
import modRuvnlSessionTokenReducer from "./state/ModRuvnl/ModSessionToken";
import modRuvnlVersionReducer from "./state/ModRuvnl/ModVersion";
import optimizierReducer from "./state/GNAOptimizer/CurrentOptimisationState";
import OptimizerRuvnlDateReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerDate";
import OptimizerRuvnlSessionReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerSession";
import OptimizerRuvnlSessionTokenReducer from "./state/GNAOptimizer/RuvnlOptimizer/OptimizerSessionToken";
import OptimizerDemoDateReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerDate";
import OptimizerDemoSessionReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerSession";
import OptimizerDemoSessionTokenReducer from "./state/GNAOptimizer/DemoOptimizer/OptimizerSessionToken";

export const store = configureStore({
  reducer: {
    menu: MenuState,
    buyerSeller: BuyerSellerFilterSlice,
    exchange: ExchangeState,
    document: DocumentSlice,
    marketMonitoring: MarketMonitoringSlice,
    discom: DiscomSlice,
    switchTabs: switchTabs,
    viewMode: viewModeReducer,
    defaultDatesSetter: defaultDatesSetterReducer,
    FilterWidthSlice: FilterWidthSliceReducer,
    demandForecast: demandForecastReducer,
    disclamerModel: disclamerModeleducer,
    FilterLoadingState: FilterLoadingStateSliceReducer,
    BlockSuggestion: BlockSuggestionSliceReducer,
    modGridcoDate: modGridcoDateReducer,
    modGridcoSession: modGridcoSessionReducer,
    modGridcoSessionToken: modGridcoSessionTokenReducer,
    modGridcoVersion: modGridcoVersionReducer,
    modLoad: modLoadReducer,
    modDemoDate: modDemoDateReducer,
    modDemoSession: modDemoSessionReducer,
    modDemoSessionToken: modDemoSessionTokenReducer,
    modDemoVersion: modDemoVersionReducer,
    modRuvnlDate: modRuvnlDateReducer,
    modRuvnlSession: modRuvnlSessionReducer,
    modRuvnlSessionToken: modRuvnlSessionTokenReducer,
    modRuvnlVersion: modRuvnlVersionReducer,
    optimizierData: optimizierReducer,
    OptimizerRuvnlDate: OptimizerRuvnlDateReducer,
    OptimizerRuvnlSession: OptimizerRuvnlSessionReducer,
    OptimizerRuvnlSessionToken: OptimizerRuvnlSessionTokenReducer,
    OptimizerDemoDate: OptimizerDemoDateReducer,
    OptimizerDemoSession: OptimizerDemoSessionReducer,
    OptimizerDemoSessionToken: OptimizerDemoSessionTokenReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
